/*
 * @Author: weiyanna weiyanna@jd.com
 * @Date: 2026-04-29 10:23:11
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @LastEditTime: 2026-05-18 16:57:43
 * @FilePath: /isp_International/src/components/NavBar/HomeNavBar/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import styles from './index.module.scss';
import defaultLogo from '@/assets/images/common/logo.png';
import { resolveNavLogoImageUrl } from '@/util/headerLogo';

interface HomeNavBarProps {
  loading: boolean;
  isHomePage?: boolean;
  isWidePage?: boolean;
  logoIcon?: string;
  /** 用户信息接口是否已返回；未决议前不展示兜底图，避免「兜底→真 logo」闪烁 */
  logoResolved?: boolean;
  isGuestUser: boolean;
  cartCount?: number;
  searchNode: React.ReactNode;
  onLogoClick: () => void;
  onOrderCenterClick: () => void;
  onCartClick: () => void;
  onBatchDownloadClick: () => void;
  onRegisterClick: () => void;
  onLoginClick: () => void;
  /** WIMP H5：S_hideOrderCenter=true 时不展示，默认 true */
  showOrderCenter?: boolean;
  orderCenterText: string;
  batchDownloadText: string;
  cartText: string;
  registerText: string;
  loginText: string;
}

const HomeNavBar: React.FC<HomeNavBarProps> = ({
  loading,
  isHomePage = false,
  isWidePage = false,
  logoIcon,
  logoResolved = false,
  isGuestUser,
  cartCount,
  searchNode,
  onLogoClick,
  onOrderCenterClick,
  onCartClick,
  onBatchDownloadClick,
  onRegisterClick,
  onLoginClick,
  showOrderCenter = true,
  orderCenterText,
  batchDownloadText,
  cartText,
  registerText,
  loginText,
}) => {
  const cartBadgeText = String(cartCount || 0);
  const cartBadgeClassName =
    cartBadgeText.length >= 2 ? `${styles.cartBadge} ${styles.cartBadgeDouble}` : styles.cartBadge;
  // logo 三态：有真 logo 直接用；否则仅在用户信息已返回时才用京东兜底图；
  // 未返回时返回空，先留出占位空间，避免「兜底图→真 logo」的闪烁
  const hasCustomLogo = Boolean(logoIcon) && typeof logoIcon === 'string';
  const logoSrc = hasCustomLogo
    ? resolveNavLogoImageUrl(logoIcon as string)
    : logoResolved
    ? defaultLogo
    : '';

  return (
    <div
      className={`${styles.homeNav} ${isHomePage ? styles.homeNavHome : ''} ${
        isWidePage ? styles.homeNavWide : ''
      }`}
      id="__position"
    >
      <div
        className={`${styles.mainRow} ${isHomePage ? styles.mainRowHome : ''} ${
          isWidePage ? styles.mainRowWide : ''
        } ${isGuestUser ? styles.mainRowGuest : ''}`}
      >
        <div
          className={`${styles.logoWrap} ${!loading ? styles.logoReady : ''}`}
          style={logoSrc ? { backgroundImage: `url(${logoSrc})` } : undefined}
          data-track={JSON.stringify({
            eventId: 'Logo',
          })}
          onClick={onLogoClick}
        />

        <div className={styles.searchWrap}>{searchNode}</div>

        {isGuestUser && (
          <div className={styles.guestActionArea}>
            <button type="button" className={styles.registerButton} onClick={onRegisterClick}>
              {registerText}
            </button>
            <button type="button" className={styles.loginButton} onClick={onLoginClick}>
              {loginText}
            </button>
          </div>
        )}

        {!isGuestUser && (
          <div className={styles.actionArea}>
            {showOrderCenter && (
              <button
                type="button"
                className={styles.actionButton}
                data-track={JSON.stringify({
                  eventId: 'OrderManagement',
                })}
                onClick={onOrderCenterClick}
              >
                <i className={`iconFont ${styles.iconOrderCenter} ${styles.actionIcon}`}></i>
                <span className={styles.actionText}>{orderCenterText}</span>
              </button>
            )}

            <button type="button" className={styles.actionButton} onClick={onBatchDownloadClick}>
              <i className={`iconFont ${styles.iconBatchBuy} ${styles.actionIcon}`}></i>
              <span className={styles.actionText}>{batchDownloadText}</span>
            </button>

            <button type="button" className={styles.actionButton} onClick={onCartClick}>
              <span className={cartBadgeClassName}>{cartBadgeText}</span>
              <i className={`iconFont ${styles.iconShopCar} ${styles.actionIcon}`}></i>
              <span className={styles.actionText}>{cartText}</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeNavBar;
